import { useRouter } from '@abyss/web/hooks/useRouter';
import { storage } from '@abyss/web/tools/storage';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useEffect } from 'react';

import { PortalData, PortalName } from '../../common/Portal';
import { callGuestSessionUrl } from '../../utils/session.utils';
import { ProviderSearchForPortal } from '../ProviderSearchForPortal/ProviderSearchForPortal';
import {
  PSXBlueGreenCanaryGraphqlApi,
  PSXBlueGreenCanaryParcelUrl,
} from './utils';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'abyss-parcel': any;
      'portal-data': any;
    }
  }
}

export const EarlyPayContainer = () => {
  const { getSearchParams } = useRouter();
  const [searchParams] = getSearchParams();
  const flags = useFlags();
  const graphQlUrl = PSXBlueGreenCanaryGraphqlApi();

  const portalData: PortalData = {
    portalMemberInfo: {
      memberInfo: [],
    },
    portalName: PortalName.EARLY_PAY,
    portalConfig: {
      basePath: '/guest',
      includeBaseCss: true,
      isGuestUser: true,
      graphQlUrl,
      theme: 'uhc',
      mapLocationUrl: '/api',
    },
  };

  useEffect(() => {
    const parcelUrl = PSXBlueGreenCanaryParcelUrl(flags, searchParams);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = parcelUrl || '';
    document.head.appendChild(script);

    callGuestSessionUrl();
  }, []);

  if (window?.location?.hostname === 'localhost') {
    storage.cookie.set('LOB-Target', 'guest');
    return <ProviderSearchForPortal portal-data={JSON.stringify(portalData)} />;
  }

  document.cookie = `LOB-Target=guest; Domain=.uhc.com; path=/;`;

  return (
    <React.Fragment>
      <abyss-parcel
        import="provider-search-for-portal"
        portal-data={JSON.stringify(portalData)}
      />
    </React.Fragment>
  );
};
